import React, { FC, useEffect, useState, memo } from 'react';
import { useAuthFetchFromRestAPI } from '../../util/api';
import ChatMessageComponent from './ChatMessageComponent';
import ChatHeadComponent from './ChatHeadComponent';
import ChatHeadHorizontalComponent from './ChatHeadHorizontalComponent';
import { ITherapyChatInfo } from "../../util/types";

type Props = { therapist: any };
const ChatComponent: FC<Props> = ({ therapist }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const { authFetch } = useAuthFetchFromRestAPI();
    const [therapies, setTherapies] = useState<ITherapyChatInfo[]>([]);
    const [selectedTherapy, setSelectedTherapy] = useState<ITherapyChatInfo | null>(null);

    const handelTherapySelection = (therapy: ITherapyChatInfo) => {
        setSelectedTherapy(therapy);
    }
    const handleResize = () => setIsMobile(window.innerWidth < 768);

    useEffect(() => {
        async function load() {
            const response = await authFetch('/api/v1/therapies/chat');
            if (response && !response.error) {
                setTherapies(response);
            }
        }

        window.addEventListener("resize", handleResize)
        void load();
    }, [])

    return (
      <div className="border-top border-1 no-x-overflow no-y-overflow w-100">
          {isMobile && therapies ?
            <div className="container-fluid">
                <ChatHeadHorizontalComponent
                  therapies={therapies}
                  selectedTherapy={selectedTherapy}
                  handleSelectTherapy={handelTherapySelection}>
                </ChatHeadHorizontalComponent>
            </div>
            : null}
          <div className="row g-0 align-items-stretch">
              {!isMobile && therapies ?
                <ChatHeadComponent
                  therapies={therapies}
                  selectedTherapy={selectedTherapy}
                  handleSelectTherapy={handelTherapySelection}>
                </ChatHeadComponent> : null}
              {selectedTherapy ?
                <ChatMessageComponent
                  key={selectedTherapy._id}
                  therapy={selectedTherapy}
                  therapist={therapist}
                  isMobile={isMobile}>
                </ChatMessageComponent> : null}
          </div>
      </div>
    )

};

export default memo(ChatComponent);
